module.exports = __webpack_public_path__ + "img/mn.34b64d4c.svg";